import aboutServices from '../../services/about';
import About from '../../model/about';

export const state = {
    about: {},
}

export const mutations = {
    setAbout(state, about) {
        state.about = about
    }
}

export const getters = {
    getAbout(state) {
        return new About(state.about);
    }
}

export const actions = {
    getAll({commit}, data = {}){
        return aboutServices.getAll(data)
        .then((response)=>{
            commit('setAbout', response.data.data)
            return response
        })
    },
    edit({commit}, {id, about}){
        return aboutServices.edit(id, about)
        .then((response)=>{
            commit('setAbout', response.data)
            return response
        })
    },
}